import React, { useCallback, useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Container, Info, Cards } from './styles';
import Header from '../../components/Header';
import NavBar from '../../components/NavBar';
import Button from '../../components/Button';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';

interface Loja {
  cd_contrato: number;
  chave: string;
  nm_razao: string;
}

const Lojas: React.FC = () => {
  const [lojasData, setLojasData] = useState<Loja[]>([]);

  const { signIn } = useAuth();
  const { addToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    const minhasLojas = localStorage.getItem('@MeuPantera:lojas');
    if (minhasLojas) {
      const { data } = JSON.parse(minhasLojas);
      setLojasData(data);
    }
  }, []);

  const handleClick = useCallback(
    async (data: Loja) => {
      try {
        await signIn({
          contrato: data.cd_contrato.toString(),
          chave: data.chave,
        });

        history.push('/dashboard');
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro',
          description: 'Ocorreu um erro ao acessar a loja selecionada.',
        });
      }
    },
    [addToast, history, signIn],
  );

  return (
    <Container>
      <NavBar />
      <div id="page-wrap">
        <Header />
        {lojasData.length === 0 ? (
          <Info>
            <h1>Ops, você não possui outras lojas...</h1>
          </Info>
        ) : (
          <Info>
            <h1>Minhas Lojas</h1>
            <Cards>
              {lojasData.map((loja) => (
                <Button
                  key={loja.cd_contrato}
                  onClick={() => handleClick(loja)}
                >
                  {loja.cd_contrato} - {loja.nm_razao}
                </Button>
              ))}
            </Cards>
          </Info>
        )}
      </div>
    </Container>
  );
};

export default Lojas;
